import { useEffect, useState } from "react";
import { Icon } from "@thetreep/ui";
import { getColor } from "@utils/colors";

type ToasterProps = {
  type: "success" | "error" | "info" | "warning";
  text: string;
  duration?: number;
};

const COLORS = {
  success: "success-strong",
  error: "error-strong",
  info: "info-strong",
  warning: "warning-strong",
};

const ICONS = {
  success: <Icon src="check_circle_line" color={getColor(COLORS.success)} />,
  error: <Icon src="alert_line" color={getColor(COLORS.error)} />,
  info: <Icon src="information_line" color={getColor(COLORS.info)} />,
  warning: <Icon src="warning_line" color={getColor(COLORS.warning)} />,
};

export const Toaster = ({ type = "info", text, duration }: ToasterProps) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  if (!visible) return null;

  return (
    <div
      className={`border border-${COLORS[type]} fixed top-32 md:top-44 right-4  w-80 max-w-[80vw] bg-white shadow-lg rounded-lg  p-6 flex items-center gap-3 z-[2000]`}
    >
      {ICONS[type]}
      <span className="flex-1 text-gray-800">{text}</span>
      <button
        onClick={() => setVisible(false)}
        className="text-gray-500 hover:text-gray-700"
      >
        <Icon src="close_line" size={20} />
      </button>
    </div>
  );
};
